import { AppConstant } from "../Utils/AppConstant";

type Props = {
  src?: string;
  height?: number| string;
  width?: number | string;
  className?: string;
};

export const GenericImage = ({
  src = `${process.env.PUBLIC_URL}/${AppConstant.Logo}`,
  height = 40,
  width = 40,
  className = "",
}: Props) => (
  <>
    <div className="">
      <img
        className={`${className} rounded-lg`}
        src={src || `${process.env.PUBLIC_URL}/${AppConstant.Logo}`}
        alt=""
        height={height}
        width={width}
      />
    </div>
  </>
);
